
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const salesrepApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listSalesReps: builder.query ({
      query: (params) => `v2/salesrep/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["SalesRep"]
    }),
    getSalesRep: builder.query ({
      query: (salesrep_id) => `v2/salesrep/${salesrep_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["SalesRep"]
    }),
    getSalesRepDiscounts: builder.query ({
      query: (salesrep_id) => `v2/discount/?salesrep=${salesrep_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["Discount"]
    }),
    getSalesRepContracts: builder.query ({
      query: (salesrep_id) => `v2/contract/?salesrep=${salesrep_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["Contract"]
    }),
    getSalesRepFinders: builder.query ({
      query: (salesrep_id) => `v2/salesrep/?parent=${salesrep_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["SalesRep"]
    }),
    updateSalesRep: builder.mutation ({
      query: ({salesrep_id, data}) => ({
        url: `v2/salesrep/${salesrep_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["SalesRep"]
    }),
    deleteSalesRep: builder.mutation ({
      query: (salesrep_id) => ({
        url: `v2/salesrep/${salesrep_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["SalesRep"]
    }),
    createSalesRep: builder.mutation ({
      query: (data) => ({
        url: `v2/salesrep/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["SalesRep"]
    }),
  })
})


export const {
  useListSalesRepsQuery,
  useLazyListSalesRepsQuery,
  useGetSalesRepQuery,
  useLazyGetSalesRepQuery,
  useGetSalesRepDiscountsQuery,
  useGetSalesRepContractsQuery,
  useGetSalesRepFindersQuery,
  useUpdateSalesRepMutation,
  useDeleteSalesRepMutation,
  useCreateSalesRepMutation
} = salesrepApi
